import { app, Component, ojs, v } from "modular-openscriptjs";
import { pageInfo, scrollToTop, empty, searchPlaceholder, eParse } from "../../helpers";
import { beginSuggestionRequest, isSuggestionRequestCurrent } from "../../helpers";
import { PAGES, dc } from "../../declarations";

import SearchBar from "../Blocks/SearchBar";
import SearchDefault from "./Search/SearchDefault";
import SearchResults from "./Search/SearchResults";
import AlgoliaSearch from "../../classes/AlgoliaSearch";

const h = app("h");

ojs(SearchDefault, SearchResults);

export default class SearchPage extends Component {
    // Bumped on every dispatched suggestions request - a response is only
    // allowed to render if it's still the latest one, so a stale keystroke's
    // suggestions never overwrite a newer keystroke's.
    _suggestionSeq = 0;

    $$app = {
        has: {
            searchCharacter: async (ed, event) => {
                const requestSeq = ++this._suggestionSeq;

                const { message } = eParse(ed);
                let query = message.get("value");

                if (empty(query)) {
                    dc.searchSuggestions.value = [];
                    return;
                }

                /**
                 * @type {AlgoliaSearch}
                 */
                let client = app("AlgoliaSearch");

                const ticket = beginSuggestionRequest();
                let result = await client.getSuggestions(query);

                // Stale response - a newer keystroke has since fired a
                // newer suggestions request. Don't overwrite it.
                if (requestSeq !== this._suggestionSeq) {
                    return;
                }

                // The user may have navigated away while this was in flight.
                if (!isSuggestionRequestCurrent(ticket)) {
                    return;
                }

                dc.searchSuggestions.value = result;
            },
        },
    };

    
    render(...args) {
        pageInfo(PAGES.SEARCH);
        scrollToTop();
        searchPlaceholder("Find anything...");

        return h.div(
            v(dc.searchQuery, (queryState) => {
                const query = queryState.value;
                if (empty(query)) {
                    return h.SearchDefault();
                } else {
                    return h.SearchResults();
                }
            }),
            ...args,
        );
    }
}

ojs(SearchPage);
